import { render, staticRenderFns } from "./MelUpload.vue?vue&type=template&id=0e5124a3&scoped=true"
import script from "./MelUpload.vue?vue&type=script&lang=js"
export * from "./MelUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5124a3",
  null
  
)

export default component.exports